import React from 'react'
import PdfPage from '../../components/PdfPage/PdfPage'
import { PRIVACY_POLICY_PDF_URL } from '../../constants'

const PrivacyPolicy = () => <PdfPage title="Privacy Policy" file={PRIVACY_POLICY_PDF_URL} />

export default PrivacyPolicy
